// App.js (Updated with Modern Design)
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import GoogleLogin from "./component/login/GoogleLogin";
import Profile from "./component/profile/Profile";
import NavBar from "./component/NavBar/NavBar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import EventSettingsForm from "./component/events/EventSettings.js";
import EventsList from "./component/events/EventList.js";
import NewEvent from "./component/events/NewEvent.js";
import Intregration from "./component/intregration/Intregration.js";
import Booking from "./component/meeting/Booking.js";
import MeetingList from "./component/meeting/MeetingList.js";
import WeeklyHours from "./component/availablity/WeeklyHours.js";
import LandingPage from "./component/meeting/LandingPage.js";
import HelpCenter from "./component/NavBar/HelpCenter.js";
import Dashboard from "./component/NavBar/Dashboard.js";
import './App.css';
import HeroPage from "./component/landing/HeroPage.js";
import TermsAndConditions from "./component/NavBar/TermsAndConditions.js";
import PrivacyPolicy from "./component/NavBar/PrivacyPolicy.js";
import TermsOfService from "./component/NavBar/TermsOfService.js";
import PaymentStatus from "./component/payment/PaymentStatus.js";
function App() {
  const isAuthenticated = () => {
    const storedUser = localStorage.getItem("user");
    console.log("Stored user:", storedUser);
    return !!storedUser;
  };

  const PrivateRoute = ({ element, ...rest }) => {
    return isAuthenticated() ? <NavBar>{element}</NavBar> : <Navigate to="/login" />;
  };

  const PublicRoute = ({ element }) => {
    return !isAuthenticated() ? element : <Navigate to="/dashboard" />;
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/booking/:schema/:usersslug/:slug" element={<Booking />} />
          <Route path="/booking/:schema/:usersslug" element={<LandingPage />} />
          <Route path="/login" element={<GoogleLogin />} />

          <Route path="/" element={<PublicRoute element={<HeroPage />} />} />

          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/home" element={<HeroPage />} />
          <Route path="/helpcenter" element={<HelpCenter />} />
          <Route path="/payment/:type" element={<PaymentStatus />} />
          {/* Private Routes */}
          <Route path="/" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
          <Route path="/meetings" element={<PrivateRoute element={<MeetingList />} />} />
          <Route path="/events/new" element={<PrivateRoute element={<NewEvent />} />} />
          <Route path="/availability" element={<PrivateRoute element={<WeeklyHours />} />} />
          <Route path="/events/:id" element={<PrivateRoute element={<EventSettingsForm />} />} />
          <Route path="/events" element={<PrivateRoute element={<EventsList />} />} />
          <Route path="/integration" element={<PrivateRoute element={<Intregration />} />} />

          {/* 404 Page */}
          <Route path="*" element={<ComingSoonPage />} />
        </Routes>
      </div>
    </Router>
  );
}

// Modern Coming Soon Page Component
const ComingSoonPage = () => {
  return (
    <div className="coming-soon-page">
      <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="floating-animation mb-4">
            <div className="gradient-circle mx-auto"></div>
          </div>

          <h1 className="display-4 fw-bold text-primary mb-3">
            Coming Soon
          </h1>

          <p className="lead text-muted mb-4">
            We're crafting something extraordinary for you.
            Stay tuned for an amazing experience!
          </p>

          <div className="progress-container mb-4">
            <div className="progress">
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                style={{ width: '75%' }}
              ></div>
            </div>
            <small className="text-muted mt-2">Development in progress - 75% complete</small>
          </div>

          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <button
              className="btn btn-primary btn-lg px-4"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
            <button
              className="btn btn-outline-primary btn-lg px-4"
              onClick={() => window.location.href = '/'}
            >
              Home Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;